import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { BellIcon } from '@moia-dev/pace-icons'
import { VehicleAlertsAreaRoutes } from './VehicleAlertsAreaRoutes'

export const VehicleAlertsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VehicleAlertsAreaRoutes.route}
      Icon={BellIcon}
    />
  )
}
